//React
import React, { FC } from 'react'
import * as Dialog from '@radix-ui/react-dialog'

// Components
import * as Styled from './styled'
import { useModal } from 'hooks'

type Props = {
  children: React.ReactNode
  onClose?: () => void
  showExit?: boolean
}

const Modal: FC<Props> = ({ children, onClose, showExit = true }: Props) => {
  const { isVisible, closeModal, triggerAnimation } = useModal()

  const handleClose = () => {
    onClose?.()
    closeModal()
  }

  return (
    <Dialog.Root open={Boolean(isVisible)} onOpenChange={handleClose}>
      <Dialog.Portal>
        <Styled.DialogOverlay />
        <Styled.DialogContent triggerAnimation={triggerAnimation}>
          {showExit && (
            <Styled.CloseButton onClick={handleClose}>
              <Styled.CloseIcon />
            </Styled.CloseButton>
          )}
          <Styled.GestureBarContainer onClick={handleClose}>
            <Styled.GestureBar />
          </Styled.GestureBarContainer>
          {children}
        </Styled.DialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default Modal
